import { TAX_SET_TAXES_ITEM } from './tax-set-taxes.js'
import { TAX_SET_ALIQS_ITEM } from './tax-set-aliqs.js'
import { TAX_SET_LINKS_ITEM } from './tax-set-links.js'

/** @type {import('../help-index.js').HelpScreen} */
export const TAX_SET_HELP = {
  screenId: 'tax-set',
  label: 'Configuración',
  navPath: 'Impuestos → Configuración',
  keywords: [
    'impuesto', 'alícuota', 'iva', 'iibb', 'percepción', 'retención', 'tipo afip',
    'concepto factura', 'configuración impuestos',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Catálogo de impuestos, sus alícuotas y la relación entre ambos. Base para facturación, agente de percepción y obligaciones impositivas.',
  sidebarItems: [
    TAX_SET_TAXES_ITEM,
    TAX_SET_ALIQS_ITEM,
    TAX_SET_LINKS_ITEM,
  ],
}
